import { Button } from '@codeparva/ui-components-library';
import React from 'react';
import { AutoPayTypes } from '../../AutoPayTypes';
import { getCardTypeFromPaymentMethodId } from '../PayRent/CardTypeIcon';
import { PaymentDetailsCard } from './PaymentDetailsCard';
import { autoPayPageLabels } from '../../constants/accountPanelConfigs';
import { Text } from '../../../../components/textVariations';

export const AutoPayEnabled = ({
  deActivateAutoPay,
  selectedLedgerData,
  payment_methods,
}: AutoPayTypes.TEnableAutoPay) => {
  const {
    financials: {
      preferred_payment_method_id,
      card_info: {
        masked_card_number = '',
        expiration_date,
        billing_info,
      } = {},
    } = {},
  } = selectedLedgerData;
  const {
    paymentInfo: { buttonLabel },
  } = autoPayPageLabels;
  const cardType = getCardTypeFromPaymentMethodId(
    payment_methods,
    preferred_payment_method_id
  );
  const withoutDashNumber = masked_card_number.replace(/-/g, '');
  const infoCardProps = {
    masked_card_number,
    cardType,
    expiration_date,
    billing_info,
  };
  return (
    <div className="enableAutoPayParentContainer">
      <div className="enableMessage">
        <Text>
          You have successfully signed up for automatic payments with the card
          of type
          <span className="has-text-weight-bold"> {cardType} </span>
          ending in
          <span className="has-text-weight-bold"> {withoutDashNumber} </span>
        </Text>
      </div>
      <div className="cardInfoSection">
        <PaymentDetailsCard {...infoCardProps} />
      </div>
      <div className="buttonContainer">
        <Button onClick={() => deActivateAutoPay()}>{buttonLabel}</Button>
      </div>
    </div>
  );
};
